module.exports = __webpack_public_path__ + "static/media/lc.31859653.svg";